import React from "react";
import { Card, Select } from "antd";
import AppColorPreview from "../../admin/groupConfig/GroupDesign/AppColorPreview/AppColorPreview.jsx";
import FUpload from "../../commons/formFields/FUpload.jsx";
import { ChantButton } from "../../../CommonComponents/index.js";

const AppDesignSettings = ({
  colors,
  logoImgType,
  setLogoImgType,
  logoList,
  transparentLogoList,
  uploadAction,
  handleImageChange,
  setPreview,
  appIconImage,
  toggleIconModal,
  handleColorChange,
  primaryColor,
  secondaryColor,
  groupName,
  preview,
}) => {
  return (
    <Card
      title="App Design & Preview"
      style={{
        marginTop: "24px",
        marginBottom: "24px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <div>
        <div style={{ marginBottom: "16px" }}>
          <div className="col-md-4">
            <p style={{ fontWeight: "bold", fontSize: "1rem", margin: "0" }}>
              Group Logo
            </p>
          </div>
          <div
            className="col-md-6"
            style={{ display: "flex", gap: "16px", alignItems: "center" }}
          >
            <div>
              <p style={{ fontWeight: "bold" }}>Image Type: </p>
              <Select
                defaultActiveFirstOption
                popupMatchSelectWidth={false}
                options={[
                  {
                    value: "regular",
                    label: "Regular",
                  },
                  {
                    value: "transparent",
                    label: "Transparent",
                  },
                ]}
                value={logoImgType}
                onChange={(val) => setLogoImgType(val)}
              />
            </div>
            <FUpload
              aspectRatio={1 / 1}
              showCropOptions={logoImgType === "regular"}
              action={uploadAction}
              isAvatar={logoImgType === "regular"}
              label="Logo"
              accept={logoImgType === "regular" ? ".jpg,.jpeg,.png" : ".png"}
              fileList={
                logoImgType === "regular" ? logoList : transparentLogoList
              }
              onChange={handleImageChange}
              onLoad={(preview) => {
                setPreview(preview);
              }}
            />
          </div>
        </div>

        <div className="row" style={{ marginBottom: "16px" }}>
          <div className="col-md-4">
            <p
              style={{
                fontWeight: "bold",
                fontSize: "1rem",
                margin: "0",
              }}
            >
              App Icon (select color
            </p>
            <p style={{ marginBottom: "6px" }}>
              The default app icon is red. Select a color that closely matches
              one of your club&apos;s colors. Note: If a member is part of 2+
              groups their app icon will switch based on group last visited.
            </p>
            <ChantButton
              className="mt-2"
              type="primary"
              onClick={toggleIconModal}
            >
              Select
            </ChantButton>
          </div>

          <div className="col-md-8 ">
            {appIconImage ? (
              <img alt="app-icon" height={100} width={100} src={appIconImage} />
            ) : (
              <div
                style={{
                  height: 100,
                  width: 100,
                  backgroundColor: "#ccc",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Icon not found
              </div>
            )}
          </div>
        </div>
      </div>
      <AppColorPreview
        colors={colors}
        handleColorChange={handleColorChange}
        isLogoTransparent={logoImgType === "transparent"}
        logoImage={logoImgType === "regular" ? logoList : transparentLogoList}
        preview={preview}
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        groupName={groupName}
      />
    </Card>
  );
};

export default AppDesignSettings;
